// extracted by css-extract-rspack-plugin
export default {"label":"AdRegions-module__label--f_kM3","label-icon":"AdRegions-module__label-icon--ZLrpt","labelIcon":"AdRegions-module__label-icon--ZLrpt"};